import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertNotice } from 'shared/components';
import _ from 'lodash';

const Irregularities = ({ irregularities }) => {
  const { t } = useTranslation();

  return (
    <div className="irregularities-container">
      <h3>{t('reviewAndCloseRoom.examineeStatus.irregularities')}</h3>
      {irregularities.length > 0 ?
        irregularities.map((item, i) => <div
          key={`irregularity-${i}`} className="irregularities-list-item">{item.irregularityType.name}
          {item.irregularityExaminees.length > 0 && _.orderBy(item.irregularityExaminees, ['lastName'],['asc']).map((examinee, idx) =>
            <div className="irregularity-examinee" key={`examine-${idx}`}>
              {`${examinee.lastName}, ${examinee.firstName}`}
            </div>)}
        </div>) :
        <AlertNotice
          message={t('reviewAndCloseRoom.examineeStatus.irregularitiesSuccess')}
          type="success"
          noBorder
        />
      }
    </div>
  );
};

export default Irregularities;
